import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static values = {
    pictureSignedId: String,
    sliderSelector: { type: String, default: "#book-slider-author" },
  }

  declare pictureSignedIdValue: string
  declare sliderSelectorValue: string

  private checkInterval: number | null = null

  connect() {
    if (!this.pictureSignedIdValue) {
      return
    }

    this.waitForSliderAndOpenVideo()
  }

  disconnect() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  }

  private waitForSliderAndOpenVideo() {
    const sliderElement =
      this.element.querySelector(this.sliderSelectorValue) ||
      document.querySelector(this.sliderSelectorValue)

    const slider = sliderElement as HTMLElement | null

    if (!slider) {
      return
    }

    this.checkInterval = window.setInterval(() => {
      if ($(slider).hasClass("slick-initialized")) {
        if (this.checkInterval) {
          clearInterval(this.checkInterval)
          this.checkInterval = null
        }

        setTimeout(() => {
          this.openVideoModal(slider)
        }, 500)
      }
    }, 100)
  }

  private openVideoModal(slider: HTMLElement) {
    const currentSlide = slider.querySelector(".slick-current")
    if (!currentSlide) {
      return
    }

    const pictureElement = currentSlide.querySelector(
      `[data-remote-modal-url-value*="${this.pictureSignedIdValue}"]`,
    ) as HTMLElement | null

    if (pictureElement) {
      pictureElement.click()
    }
  }
}
